import { Component, OnInit, ChangeDetectorRef, ViewChild, Input, ElementRef, AfterViewInit, SimpleChanges, OnChanges } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'kt-mat-table-responsive',
  templateUrl: './mat-table-responsive.component.html'
})
export class MatTableResponsiveComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() columns: Array<any> = new Array<any>();
  @Input() rows: Array<any> = new Array<any>();
  @Input() sorting = true;
  @Input() pagination = true;
  @Input() filter = true;
  @Input() filterColumns = [];
  @Input() wrapperClasses: string = "table-wrapper-box";
  displayedColumns: Array<any> = new Array<any>();
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.displayedColumns = this.columns.map(c => c.name);
  }

  ngOnChanges(simpleChange: SimpleChanges): void {
    if (simpleChange["rows"] && simpleChange["rows"].currentValue != simpleChange["rows"].previousValue) {
      if (simpleChange["rows"].currentValue && simpleChange["rows"].currentValue.length > 0) {
        this.dataSource = new MatTableDataSource(this.rows);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        if (this.filterColumns.length > 0) this.dataSource.filterPredicate = this.createFilterPredicate.bind(this);
        this
      } else {
        this.dataSource = new MatTableDataSource([]);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  isSortDisabled(column): boolean {
    if (this.sorting) {
      return isNullOrUndefined(column.sorting) ? false : !column.sorting;
    } else {
      return true;
    }
  }

  applyFilter(event: KeyboardEvent) {
    let filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  createFilterPredicate(data: any, filter): boolean {
    return this.filterColumns.some(column => (data[column].toString().indexOf(filter) > -1));
  }
}